import React, { useEffect } from 'react'
import { Grid, Typography, BackButton } from '@paintscout/ui'
import BasePage from 'src/components/layouts/BasePage'
import { BackLink } from '@paintscout/react-quote'
import { useNavContext } from 'src/components/common/Header/SideNav'

export interface NotAccessibleProps {
  content?: React.ReactNode
}

export function NotAccessible({ content }: NotAccessibleProps) {
  const { setHideBackLink } = useNavContext()

  useEffect(() => {
    setHideBackLink?.(true)
    return () => setHideBackLink?.(false)
  }, [])

  return (
    <BasePage width="xl">
      <BackLink>
        <BackButton />
      </BackLink>
      <Grid container spacing={3} direction="column" alignItems="center" justifyContent="center">
        <Grid item xs={8} sm={6} md={4} style={{ textAlign: 'center' }}>
          <Typography variant={'h2'} style={{ marginTop: 32, marginBottom: 16 }}>
            Access Restricted
          </Typography>
          {content ? (
            content
          ) : (
            <>
              <Typography variant="body1">This page is not accessible with your current permissions.</Typography>
              <Typography variant="body1">Please ask your account owner for access.</Typography>
            </>
          )}
        </Grid>
      </Grid>
    </BasePage>
  )
}

export default NotAccessible
